import { type ReactElement } from 'react';
import { Outlet } from 'react-router';

export function AuthLayout(): ReactElement {
  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-4 py-8">
      <div className="w-full max-w-lg bg-white p-10">
        <Outlet />
      </div>
    </main>
  );
}
